import { render, staticRenderFns } from "./videopage.vue?vue&type=template&id=59f63d6c&scoped=true"
import script from "./videopage.vue?vue&type=script&lang=js"
export * from "./videopage.vue?vue&type=script&lang=js"
import style0 from "./videopage.vue?vue&type=style&index=0&id=59f63d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f63d6c",
  null
  
)

export default component.exports